import "./resource-room-projects.css";

export function ResourceRoomCoverPage(): React.JSX.Element {
  return (
    <main className="resource-cover">
      <section className="resource-cover-hero" aria-labelledby="resource-cover-title">
        <figure className="resource-cover-visual">
          <img
            src="/brand/resource-room-cover.webp"
            alt="资源教师在资源教室中统筹个训和小组课程的插画"
          />
        </figure>
        <div className="resource-cover-copy">
          <p className="resource-cover-brand">七维教育&amp;融合星球</p>
          <h1 id="resource-cover-title">资源教室排课助手</h1>
          <a className="solid-button resource-cover-action" href="/projects">
            开始使用
            <span aria-hidden="true">→</span>
          </a>
        </div>
      </section>
    </main>
  );
}
